var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2179 8.42449L19.9095 8.42449L19.9095 15.7767L4.98157 15.7974L4.98157 17.3669L21.1981 17.3669L21.2179 8.42449Z",
    fill: "#717F8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9986 5.90474L2.78213 5.90474L2.78212 14.8265L18.9986 14.8265L18.9986 5.90474ZM7.63915 10.3863C7.63915 8.52758 9.10617 6.99931 10.8904 6.99931C12.6746 6.99931 14.1416 8.52758 14.1416 10.3863C14.1416 12.245 12.6746 13.7733 10.8904 13.7733C9.10617 13.7733 7.63915 12.245 7.63915 10.3863Z",
    fill: "#717F8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.e317a9f4b18fa642eacf5e01787eb2e3.svg";
export { ForwardRef as ReactComponent };